var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.6 25.6",
    style: {
      enableBackground: "new 0 0 25.6 25.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000121987691664228219290000005013437845348614786_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    className: "st0",
    d: "M12.8,0C5.8,0,0,5.7,0,12.8s5.7,12.8,12.8,12.8c4.3,0,8.3-2.1,10.7-5.7 c1.4-2.1,2.2-4.6,2.2-7.1C25.6,5.8,19.9,0,12.8,0z M12.8,23.3C7,23.4,2.3,18.6,2.3,12.8S7,2.3,12.8,2.2c5.8,0,10.6,4.7,10.6,10.5 c0,0,0,0,0,0l0,0C23.3,18.6,18.6,23.3,12.8,23.3L12.8,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    className: "st0",
    d: "M12.4,15.7c-1.2-0.1-1.2-0.1-1.1-1.3c-0.1-1.2,0.5-2.3,1.5-3c0.2-0.2,0.4-0.4,0.7-0.6 c0.5-0.4,0.8-0.8,0.5-1.4c-0.3-0.5-1-0.8-1.6-0.7c-0.7,0.1-1.2,0.6-1.4,1.3c-0.1,0.5-0.3,0.6-0.8,0.5c-0.4-0.1-0.7-0.1-1.1-0.1 c-0.7,0-0.7-0.4-0.6-0.8c0.4-1.6,1.8-2.8,3.4-2.8c0.9-0.1,1.9,0.1,2.8,0.5c1.5,0.6,2.2,2.3,1.7,3.8c-0.2,0.4-0.4,0.8-0.7,1.1 c-0.4,0.4-0.8,0.8-1.3,1.2c-0.4,0.3-0.7,0.9-0.7,1.4C13.6,15.8,13.6,15.8,12.4,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    className: "st0",
    d: "M12.4,19.6c-0.7,0-1.2-0.5-1.2-1.2c0,0,0,0,0,0l0,0v-0.1c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0 l0,0c0.7,0,1.2,0.5,1.2,1.2l0,0C13.7,19.1,13.1,19.6,12.4,19.6C12.4,19.6,12.4,19.6,12.4,19.6L12.4,19.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/help-active.78216503edddd18352cce84b71321091.svg";
export { ForwardRef as ReactComponent };